import {useFormContext} from 'react-hook-form'

import {mapVerticalToDeliveryType} from '../utils/map-vertical-to-delivery-type'

export function useDeliveryType() {
  const {watch} = useFormContext()

  return mapVerticalToDeliveryType(watch('selected_submode') || watch('vertical_name'))
}
